import React, { useState } from 'react';
import PizzaTurno from './PizzaTurno';
import MapaPostos from './MapaPostos';
import { construirFiltrosAPI } from '../../utils/filtrosHelper';

const GraficoAlternado = ({ dadosTurno, filtros, loading, onCrossFilter, filtroCruzadoAtivo }) => {
  const [abaAtiva, setAbaAtiva] = useState('turno');

  return (
    <div className="bg-white rounded-3xl shadow-none border border-gray-200 overflow-hidden h-full flex flex-col w-full max-w-full min-h-0">
      {/* Tabs */}
      <div className="flex border-b border-gray-200 flex-shrink-0 w-full">
        <button
          onClick={() => setAbaAtiva('turno')}
          className={`flex-1 font-medium transition-colors duration-200 ${abaAtiva === 'turno'
            ? ' text-orange-500 border-b-2 border-orange-500'
            : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
            }`}
          style={{ padding: 'var(--space-fluid-xs) var(--space-fluid-sm)', fontSize: 'var(--text-fluid-sm)' }}
        >
          Abast./turno
        </button>
        <button
          onClick={() => setAbaAtiva('mapa')}
          className={`flex-1 font-medium transition-colors duration-200 ${abaAtiva === 'mapa'
            ? ' text-orange-500 border-b-2 border-orange-500'
            : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
            }`}
          style={{ padding: 'var(--space-fluid-xs) var(--space-fluid-sm)', fontSize: 'var(--text-fluid-sm)' }}
        >
          Mapa Postos
        </button>
      </div>

      {/* Conteúdo */}
      <div className="flex-1 flex flex-col min-h-0 w-full max-w-full overflow-hidden" style={{ padding: 'var(--space-fluid-xs)' }}>
        {abaAtiva === 'turno' ? (
          <PizzaTurno
            dados={dadosTurno}
            loading={loading}
            onCrossFilter={(valor) => onCrossFilter && onCrossFilter('turno', valor)}
            filtroCruzadoAtivo={filtroCruzadoAtivo?.turno?.valor || null}
            semWrapper={true}
          />
        ) : (
          <div className="flex-1 flex flex-col min-h-0 w-full max-w-full overflow-hidden">
            <MapaPostos
              filtros={construirFiltrosAPI(filtros || {})}
              onCrossFilter={(tipo, valor) => onCrossFilter && onCrossFilter(tipo, valor)}
              filtroCruzadoAtivo={filtroCruzadoAtivo}
              semWrapper={true}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default GraficoAlternado;

